import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { NodeService } from '../../../shared/services/nodeservice.service';
import { RedemptionApplications } from '../../../shared/services/redemption-applications';
import { FormGroup, FormBuilder, FormControl } from "@angular/forms";

interface applicationStatus {
    statusName: string;
    value: string;
}

@Component({
    selector: 'app-redemptions-applications',
    templateUrl: './redemptions-applications.component.html'
})
export class RedemptionApplicationsComponent implements OnInit {

    loading: boolean;
    files1: RedemptionApplications[];
    selectedNode1: RedemptionApplications;

    cols: any[];

    filterForm: FormGroup;
    applicationStatus: applicationStatus[];
    selectedStatus: applicationStatus[];
    status: any;

    constructor(private title: Title, private router: Router, private nodeService: NodeService, private fb: FormBuilder) {
        this.title.setTitle('Redemptions | XYZ Corp.');

        this.status = [
            { statusName: 'Company Approved', value: '1' },
            { statusName: 'Company Rejected', value: '2' },
            { statusName: 'CPU Processed', value: '3' },
            { statusName: 'CPU Rejected', value: '4' },
            { statusName: 'New Beneficial', value: '5' },
            { statusName: 'New Registered', value: '6' }
        ];
    }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });

        this.loading = true;
        this.nodeService.getRedemptionApplications().then(files => this.files1 = files);

        this.filterForm = this.fb.group({
            'applicationStatus': new FormControl(null),
            'dateFrom': new FormControl(null),
            'dateTo': new FormControl(null),
            'searchText': new FormControl(null),
        });

    }

    setStatusClass(status) {
        switch (status) {
            case 'CPU Processed':
                return 'green';
            case 'New Beneficial':
                return 'grey';
            case 'New Registered':
                return 'grey';
            case 'Company Approved':
                return 'blue';
            case 'Company Rejected':
                return 'red';
            case 'CPU Rejected':
                return 'red';
        }
    }

}
